export default {
  props: {
    name: String,
    size: String,
    color: String
  }
};